var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.8223H24C28.2426 12.8223 30.3639 12.8223 31.6819 14.1775C33 15.5328 33 17.7141 33 22.0767V25.1615C33 29.5242 33 31.7055 31.6819 33.0607C30.3639 34.416 28.2426 34.416 24 34.416H15C9.34314 34.416 6.51472 34.416 4.75736 32.609C3 30.8019 3 27.8935 3 22.0767V18.9919C3 13.1751 3 10.2667 4.75736 8.45965C6.17199 7.00503 8.28065 6.72135 12 6.66602H15",
    fill: "#667185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.8223H24C28.2426 12.8223 30.3639 12.8223 31.6819 14.1775C33 15.5328 33 17.7141 33 22.0767V25.1615C33 29.5242 33 31.7055 31.6819 33.0607C30.3639 34.416 28.2426 34.416 24 34.416H15C9.34314 34.416 6.51473 34.416 4.75736 32.609C3 30.8019 3 27.8935 3 22.0767V18.9919C3 13.1751 3 10.2667 4.75736 8.45965C6.17199 7.00503 8.28065 6.72135 12 6.66602H15",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 22.084C24 23.3611 25.0074 24.3965 26.25 24.3965C27.4926 24.3965 28.5 23.3611 28.5 22.084C28.5 20.8069 27.4926 19.7715 26.25 19.7715C25.0074 19.7715 24 20.8069 24 22.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.35 12.834C28.4484 12.3359 28.5 11.8203 28.5 11.2923C28.5 7.03513 25.1421 3.58398 21 3.58398C16.8579 3.58398 13.5 7.03513 13.5 11.2923C13.5 11.8203 13.5516 12.3359 13.65 12.834",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35 12.834C28.4484 12.3359 28.5 11.8203 28.5 11.2923C28.5 7.03513 25.1421 3.58398 21 3.58398C16.8579 3.58398 13.5 7.03513 13.5 11.2923C13.5 11.8203 13.5516 12.3359 13.65 12.834",
    stroke: "#667185",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDark);
export default __webpack_public_path__ + "static/media/wallet-dark.01d6e4b077237036399e2b412ff5a47a.svg";
export { ForwardRef as ReactComponent };